// Brand assets live in /public/brand — replace the files there to change the logo or seals.
export const LOGO = "/brand/logo.jpeg";
export const SEAL = "/brand/trust-seal.jpeg";
export const SEAL_GOLD = "/brand/trust-seal-gold.jpeg";
export const EMBLEM_TRUST = "/brand/seal-trust.png";
export const EMBLEM_FAMILY = "/brand/seal-family.png";

// Page covers & lifestyle photos live in /public/images — replace a file (same name) to swap a picture.
export const IMG = {
  heroHome: "/images/hero-home.png",
  heroStory: "/images/hero-story.png",
  heroExperience: "/images/hero-experience.png",
  heroCollection: "/images/hero-collection.png",
  heroQuality: "/images/hero-quality.png",
  heroFarm: "/images/hero-farm.png",
  heroSustain: "/images/hero-sustain.png",
  heroPromise: "/images/hero-promise.png",
  heroAcademy: "/images/hero-academy.png",
  heroFaq: "/images/hero-faq.png",
  soilHands: "/images/soil-hands.png",
  familyDinner: "/images/family-dinner.png",
  moringaBowl: "/images/moringa-powder.png",
  moringaTea: "/images/moringa-tea.png",
  spirulina: "/images/spirulina.png",
  amla: "/images/amla.png",
  ashwagandha: "/images/ashwagandha.png",
  lab: "/images/lab-scientist.png",
  dewyLeaf: "/images/dewy-leaf.png",
  farmerPortrait: "/images/farmer-portrait.png",
  foundersHero: "/images/founders-hero.jpg",
  founderSadhana: "/images/founder-sadhana.jpg",
  founderSujata: "/images/founder-sujata.jpg",
  twoJourneys: "/images/two-journeys.jpg",
  familyVideoPoster: "/images/family-video-poster.jpg",
  carouselSlide2: "/images/slide-founders.png",
  carouselSlide3: "/images/slide-diabetic.png",
  footerLandscape: "/images/footer-landscape.jpg",
  categoryHubHero: "/images/category-header.png",
  homeNewHero1: "/images/home-new/slide-jamun-jackfruit.jpg",
  homeNewHero2: "/images/home-new/slide-moringa-greens.jpg",
  homeNewHero3: "/images/home-new/slide-seeds-berries.jpg",
};
